import React from "react";

class NavBar extends React.Component {
    render () {
        return (
            <>
            <nav className="navbar fixed-top navbar-light bg-custom justify-content-between">
                <div className="container-fluid" color={"white"}>
                    <div>
                    <img src={"icon.png"}/>
                        {"      "}
                    <a className="navbar-brand white" href="" >not_wordle.exe</a>
                    </div>

                <span className="form-inline float-right d-flex ">
                    <button className=" topButton" id="h" >_</button>

                    <button className="topButton" id="cont" ></button>
                    <button className=" topButton" id="refresh" onClick={this.props.reset}>X</button>

                </span>
                </div>
            </nav>
                </>
        )
    }

}

export default NavBar;